export const SupportConfiguartion = {
    columns:[
        {headerName:"User ID",mappedValue:"login_id"},
        {headerName:"Name",mappedValue:"userDetails.name"},
        {headerName:"Query Date",mappedValue:"creation_time"},
        {headerName:"Query Type",mappedValue:"support_class"},
        {headerName:"Query Reason",mappedValue:"complaint"},
        {headerName:"Remarks",mappedValue:"remarks"},
        {headerName:"Status",mappedValue:"status"},
        {headerName:"Priority",mappedValue:"priority"},
        {headerName:"Assign To",mappedValue:"immediate_id"},
    ],
    Actions:["Image","Assign"],
    search:[
        {"name":"extendedAttributes.userDetails.name"},
        {"loginId":"loginId"},
        {"supportClass":"supportClass"},
    ]
}
export const NewSupportConfiguartion = {
    columns:[
        {headerName:"User ID",mappedValue:"loginId"},
        {headerName:"Name",mappedValue:"userDetails.name"},
        {headerName:"Query Date",mappedValue:"creationTime"},
        {headerName:"Query Type",mappedValue:"supportClass"},
        {headerName:"Query Reason",mappedValue:"complaint"},
        {headerName:"Remarks",mappedValue:"remarks"},
        {headerName:"Status",mappedValue:"status"},
        {headerName:"Priority",mappedValue:"priority"},
        {headerName:"Assign To",mappedValue:"immediateId"},
    ],
    Actions:["Image","Assign"],
    search:[
        {"name":"extendedAttributes.userDetails.name"},
        {"loginId":"loginId"},
        {"supportClass":"supportClass"},
    ]
}